import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { orderTemplateGroup, orderTemplateType } from 'components/discovery/pdp/create-order-template/typing/create-order-template-types.js'

/** @deprecated Order templates are created through `OrderTemplatesStore.createOrderTemplate` via `ORDER_TEMPLATES_STORE`. */
export const CREATE_ORDER_TEMPLATE_API = Symbol('CREATE_ORDER_TEMPLATE_API')
export const ORDER_TEMPLATE_TYPES_API = Symbol('ORDER_TEMPLATE_TYPES_API')
export const ORDER_TEMPLATE_GROUPS_API = Symbol('ORDER_TEMPLATE_GROUPS_API')

export type CreateOrderTemplateResponse = {
  success: boolean
  id?: number
}

/** @deprecated Use `OrderTemplatesStore.createOrderTemplate` via `ORDER_TEMPLATES_STORE`. */
export class CreateOrderTemplateRequest {
  endpoint: string
  token: string
  name: string
  group_id: number | string
  type: string

  constructor(endpoint: string, token: string, name: string, group_id: number | string, type: string) {
    this.endpoint = endpoint
    this.token = token
    this.name = name
    this.group_id = group_id
    this.type = type
  }
}

/** @deprecated Use `OrderTemplatesStore.createOrderTemplate` via `ORDER_TEMPLATES_STORE`. */
export interface CreateOrderTemplateApi {
  createOrderTemplate(request: CreateOrderTemplateRequest): Promise<CreateOrderTemplateResponse>
}

/** @deprecated Use `FakeOrderTemplatesAPI` via `ORDER_TEMPLATES_API`. */
@registerDependency(FAKE, CREATE_ORDER_TEMPLATE_API)
export class FakeCreateOrderTemplateApi implements CreateOrderTemplateApi {
  createRequests: CreateOrderTemplateRequest[] = []
  createResponse: CreateOrderTemplateResponse = { success: true, id: 1 }

  createOrderTemplate(request: CreateOrderTemplateRequest): Promise<CreateOrderTemplateResponse> {
    this.createRequests.push(request)
    return Promise.resolve(this.createResponse)
  }
}

/** @deprecated Use `RealOrderTemplatesAPI` via `ORDER_TEMPLATES_API`. */
@registerDependency(REAL, CREATE_ORDER_TEMPLATE_API)
export class RealCreateOrderTemplateApi implements CreateOrderTemplateApi {
  async createOrderTemplate(request: CreateOrderTemplateRequest): Promise<CreateOrderTemplateResponse> {
    const response = await fetch(request.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${request.token}` },
      body: JSON.stringify({ name: request.name, group_id: request.group_id, type: request.type }),
    })
    return await response.json()
  }
}

export class GetOrderTemplateTypesRequest {
  endpoint: string
  token: string

  constructor(endpoint: string, token: string) {
    this.endpoint = endpoint
    this.token = token
  }
}

export interface OrderTemplateTypesApi {
  getOrderTemplateTypes(request: GetOrderTemplateTypesRequest): Promise<orderTemplateType[]>
}

@registerDependency(FAKE, ORDER_TEMPLATE_TYPES_API)
export class FakeOrderTemplateTypesApi implements OrderTemplateTypesApi {
  requests: GetOrderTemplateTypesRequest[] = []
  response: orderTemplateType[] = []

  getOrderTemplateTypes(request: GetOrderTemplateTypesRequest): Promise<orderTemplateType[]> {
    this.requests.push(request)
    return Promise.resolve(this.response)
  }
}

@registerDependency(REAL, ORDER_TEMPLATE_TYPES_API)
export class RealOrderTemplateTypesApi implements OrderTemplateTypesApi {
  async getOrderTemplateTypes(request: GetOrderTemplateTypesRequest): Promise<orderTemplateType[]> {
    const response = await fetch(request.endpoint, {
      method: 'GET',
      headers: { Authorization: `Bearer ${request.token}` },
    })
    return await response.json()
  }
}

export class GetOrderTemplateGroupsRequest {
  endpoint: string
  token: string

  constructor(endpoint: string, token: string) {
    this.endpoint = endpoint
    this.token = token
  }
}

export interface OrderTemplateGroupsApi {
  getOrderTemplateGroups(request: GetOrderTemplateGroupsRequest): Promise<orderTemplateGroup[]>
}

@registerDependency(FAKE, ORDER_TEMPLATE_GROUPS_API)
export class FakeOrderTemplateGroupsApi implements OrderTemplateGroupsApi {
  requests: GetOrderTemplateGroupsRequest[] = []
  response: orderTemplateGroup[] = []

  getOrderTemplateGroups(request: GetOrderTemplateGroupsRequest): Promise<orderTemplateGroup[]> {
    this.requests.push(request)
    return Promise.resolve(this.response)
  }
}

@registerDependency(REAL, ORDER_TEMPLATE_GROUPS_API)
export class RealOrderTemplateGroupsApi implements OrderTemplateGroupsApi {
  async getOrderTemplateGroups(request: GetOrderTemplateGroupsRequest): Promise<orderTemplateGroup[]> {
    const response = await fetch(request.endpoint, {
      method: 'GET',
      headers: { Authorization: `Bearer ${request.token}` },
    })
    return await response.json()
  }
}
